'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { fromJS } from 'immutable';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import { AppContainer } from 'react-hot-loader';
import configureStore from './store';
import ReactModal from 'react-modal';
import queryString from 'query-string';
import * as Sentry from '@sentry/browser';
import clientConfig from '../etc/client-config.json';

import matchesPolyfill from './utils/matchesPolyfill';
import { navigate as navigateGoogle } from './utils/googleAnalytics';
import { navigate as navigateYandex, sendEvent } from './utils/yandexMetrika';

if (process.env.BROWSER) {
  require('./ui/main.styl');
}

function renderClientApp () {
  const indexApp = require('./index').default;

  const ClientApp = (
    <AppContainer>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          { indexApp }
        </ConnectedRouter>
      </Provider>
    </AppContainer>
  );

  ReactDOM.hydrate(ClientApp, rootEl);
}

const initialState = fromJS(window.__INITIAL_STATE__ || {});
const history = createHistory();

function changeLocation (location) {
  const search = queryString.parse(location.search);
  const pathname = location.pathname;

  delete search.bounds;

  const newLocation = pathname + queryString.stringify(search);

  if (changeLocation.prev !== newLocation) {
    sendEvent('view-mode');
    navigateGoogle(location.pathname + location.search);
    navigateYandex(location.pathname + location.search, changeLocation.prev);

    try {
      window.Ya.adfoxCode.clearSession();
      window.Ya.adfoxCode.reload();
    } catch (e) {}
  }

  changeLocation.prev = newLocation;
}
changeLocation.prev = null;

window && Sentry.init({
  dsn: 'https://7ad25e77b89e4bac9adaa22afb8ac67b@sentry.n1.ru/29',
  release: clientConfig.release,
  integrations: [
    new Sentry.Integrations.InboundFilters({
      allowUrls: [/(\b)(mlsn)\.ru(?!(\.\w+))/],
      ignoreErrors: [
        'Cannot read property \'setTimeout\' of null',
        'Cannot read property \'ownerDocument\' of null',
        'Permission denied',
        'top.GLOBALS',
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'http://tt.epicplay.com',
        'Can\'t find variable: ZiteReader',
        'jigsaw is not defined',
        'ComboSearch is not defined',
        'http://loading.retry.widdit.com/',
        'atomicFindClose',
        'fb_xd_fragment',
        'bmi_SafeAddOnload',
        'EBCallBackMessageReceived',
        'conduitPage',
        'Error: Can\'t execute code from a freed script',
        'JSON syntax error',
        'SyntaxError: JSON syntax error',
        'Error: Не удается выполнить программу из освобожденного сценария',
        'can\'t access dead object',
        'TypeError: can\'t access dead object',
        'VK is not defined',
        'ReferenceError: VK is not defined'
      ],
      denyUrls: [
        /\/(gtm|ga|analytics)\.js/i,
        /leaflet\.js/i,
        /freedraw\.js/i,
        /banners\.adfox\.ru/i,
        /graph\.facebook\.com/i,
        /connect\.facebook\.net\/en_US\/all\.js/i,
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        /extensions\//i,
        /^chrome:\/\//i,
        /127\.0\.0\.1:4001\/isrunning/i,
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        /googlesyndication\.com/i,
        /\/FD126C42\-EBFA\-4E12\-B309\-BB3FDD723AC1\/main\.js/i
      ]
    })
  ],
});

history.listen(changeLocation);

const store = configureStore(initialState, history);
const rootEl = document.getElementById('root');

ReactModal.setAppElement(rootEl);

// применяем полифилы
matchesPolyfill();

// General render
renderClientApp();


// Hot Module Replacement API render
if (module.hot) {
  module.hot.accept('./index', renderClientApp);
}



// WEBPACK FOOTER //
// ./src/client.jsx